import React, { useState } from 'react';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { toast } from 'react-toastify';
import searchIcon from '../../../../assets/image/search-status.svg';
import { FiBox, FiSliders } from 'react-icons/fi';

const CreateNewListModal = ({ isOpen, onClose, onSaveSuccess }) => {
	const [listName, setListName] = useState('');
	const [description, setDescription] = useState('');
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [errorName, setErrorName] = useState('');
	const [errorDesc, setErrorDesc] = useState('');
	const [loading, setLoading] = useState(false);

	const handleReset = () => {
		setListName('');
		setDescription('');
		setSearchQuery('');
		setSelectedProducts([]);
		setErrorName('');
		setErrorDesc('');
		setLoading(false);
	};

	const handleCloseModal = () => {
		handleReset();
		onClose();
	};

	const handleSubmit = async (e) => {
		if (e) e.preventDefault();

		let isValid = true;
		if (!listName || !listName.trim()) {
			setErrorName('List Name is required');
			isValid = false;
		}
		if (!description || !description.trim()) {
			setErrorDesc('Description is required');
			isValid = false;
		}

		if (!isValid) return;

		try {
			setLoading(true);
			const newListData = {
				name: listName.trim(),
				description: description.trim(),
				created_date: new Date().toLocaleDateString('en-GB'),
				product_count: selectedProducts.length,
			};

			if (onSaveSuccess) {
				await onSaveSuccess(newListData);
			}

			toast.success('Product List created successfully');
			handleCloseModal();
		} catch (err) {
			toast.error(err?.message || 'Failed to create list');
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			className="add-productgroup-modal create-list-modal-wrapper"
			headerClassName="bg-white border-0"
			isOpen={isOpen}
			onClose={handleCloseModal}
			cancelButton={handleCloseModal}
			title="Create New List"
		>
			<form onSubmit={handleSubmit} noValidate className="add-productgroup-form">
				<div className="mb-3">
					<InputField
						label="List Name"
						placeholder="Enter list name"
						type="text"
						required={true}
						name="list_name"
						autoFocus={true}
						value={listName}
						onChange={(val) => {
							setListName(val);
							if (val && val.trim()) setErrorName('');
							else setErrorName('List Name is required');
						}}
						error={errorName}
					/>
				</div>

				<div className="mb-3">
					<InputField
						label="Description"
						placeholder="Enter description"
						type="text"
						required={true}
						name="description"
						multiline={true}
						rows={3}
						value={description}
						onChange={(val) => {
							setDescription(val);
							if (val && val.trim()) setErrorDesc('');
							else setErrorDesc('Description is required');
						}}
						error={errorDesc}
					/>
				</div>

				<hr className="my-4 text-secondary opacity-25" />

				<div className="mb-3">
					<div className="fw-bold fs-5 text-dark mb-1">Add Products</div>
					<div className="fs-6 text-muted mb-3">
						Search and select multiple products to add to this list.
					</div>

					<div className="row g-2 mb-3 align-items-center">
						<div className="col position-relative">
							<img
								src={searchIcon}
								alt="search"
								className="position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"
								width="16"
								height="16"
							/>
							<input
								type="text"
								className="form-control ps-5 py-2"
								placeholder="Search by product name, SKU or barcode"
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
							/>
						</div>
						<div className="col-auto">
							<button
								type="button"
								className="btn btn-outline-secondary d-flex align-items-center gap-2 py-2 px-3"
							>
								<FiSliders /> Filters <span>∨</span>
							</button>
						</div>
					</div>

					<div className="d-flex justify-content-between align-items-center mb-2 font-14">
						<span className="fw-semibold text-dark">
							{selectedProducts.length} products selected
						</span>
						{selectedProducts.length > 0 && (
							<span
								className="text-muted cursor-pointer font-12"
								onClick={() => setSelectedProducts([])}
							>
								Clear All
							</span>
						)}
					</div>

					<div className="border border-secondary-subtle rounded-3 p-4 text-center bg-white">
						<div className="d-inline-flex align-items-center justify-content-center p-3 bg-primary-subtle text-primary rounded-3 mb-2 fs-4">
							<FiBox />
						</div>
						<div className="fw-bold text-dark fs-6 mb-1">
							No products selected yet
						</div>
						<div className="text-muted fs-6">
							Search and select products to add to this list.
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-end gap-3 mt-4 pt-2">
					<Button
						type="submit"
						button="Save"
						className="btn-primary add-pgroup px-4"
						loader={loading}
						onClick={handleSubmit}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup px-4"
						onClick={handleCloseModal}
					/>
				</div>
			</form>
		</Modal>
	);
};

export default CreateNewListModal;
